var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.is_error)?_c('error',{attrs:{"code":_vm.errorCode,"message":_vm.errorMessage}}):_vm._e(),_c('navigation'),_c('sidebar'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }